// This file is initially auto-generated by the YNAP private Figma plugin [LuxExperience Typestack Generator](https://www.figma.com/community/plugin/1517875828109926887/LuxExperience-Typestack-Generator)

export default {
  'nap-en': {
    'header-2xl': {
      font: "normal 300 64px/125% 'Chronicle Display', 'MSung PRC Medium'",
      letterSpacing: '0px',
      '@media (min-width: 1024px)': {
        font: "normal 300 96px/125% 'Chronicle Display', 'MSung PRC Medium'"
      }
    },
    'header-2xl-styled': {
      font: "normal 300 64px/125% 'Chronicle Display', 'MSung PRC Medium'",
      letterSpacing: '0px',
      textTransform: 'uppercase',
      '@media (min-width: 1024px)': {
        font: "normal 300 96px/125% 'Chronicle Display', 'MSung PRC Medium'"
      }
    },
    'header-xl': {
      font: "normal 300 48px/125% 'Chronicle Display', 'MSung PRC Medium'",
      letterSpacing: '0px',
      '@media (min-width: 1024px)': {
        font: "normal 300 64px/125% 'Chronicle Display', 'MSung PRC Medium'"
      }
    },
    'header-xl-styled': {
      font: "normal 300 48px/125% 'Chronicle Display', 'MSung PRC Medium'",
      letterSpacing: '0px',
      textTransform: 'uppercase',
      '@media (min-width: 1024px)': {
        font: "normal 300 64px/125% 'Chronicle Display', 'MSung PRC Medium'"
      }
    },
    'header-lg': {
      font: "normal 300 32px/125% 'Chronicle Display', 'MSung PRC Medium'",
      letterSpacing: '0px',
      '@media (min-width: 1024px)': {
        font: "normal 300 48px/125% 'Chronicle Display', 'MSung PRC Medium'"
      }
    },
    'header-lg-styled': {
      font: "normal 300 32px/125% 'Chronicle Display', 'MSung PRC Medium'",
      letterSpacing: '0px',
      textTransform: 'uppercase',
      '@media (min-width: 1024px)': {
        font: "normal 300 48px/125% 'Chronicle Display', 'MSung PRC Medium'"
      }
    },
    'header-md': {
      font: "normal 400 24px/125% 'Chronicle Display', 'MSung PRC Medium'",
      letterSpacing: '0px',
      '@media (min-width: 1024px)': {
        font: "normal 400 32px/125% 'Chronicle Display', 'MSung PRC Medium'"
      }
    },
    'header-md-styled': {
      font: "normal 300 24px/125% 'Chronicle Display', 'MSung PRC Medium'",
      letterSpacing: '0px',
      textTransform: 'uppercase',
      '@media (min-width: 1024px)': {
        font: "normal 300 32px/125% 'Chronicle Display', 'MSung PRC Medium'"
      }
    },
    'header-sm': {
      font: "normal 400 20px/125% 'Chronicle Display', 'MSung PRC Medium'",
      letterSpacing: '0px',
      '@media (min-width: 1024px)': {
        font: "normal 400 24px/125% 'Chronicle Display', 'MSung PRC Medium'"
      }
    },
    'header-sm-styled': {
      font: "normal 400 20px/125% 'Chronicle Display', 'MSung PRC Medium'",
      letterSpacing: '0px',
      textTransform: 'uppercase',
      '@media (min-width: 1024px)': {
        font: "normal 400 24px/125% 'Chronicle Display', 'MSung PRC Medium'"
      }
    },
    'header-xs': {
      font: "normal 400 20px/125% 'Chronicle Display', 'MSung PRC Medium'",
      letterSpacing: '0px'
    },
    'header-2xs': {
      font: "normal 400 18px/125% 'Chronicle Display', 'MSung PRC Medium'",
      letterSpacing: '0px'
    },
    'header-3xs': {
      font: "normal 400 16px/125% 'Chronicle Display', 'MSung PRC Medium'",
      letterSpacing: '0px'
    },
    'paragraph-lg': {
      font: "normal 400 18px/150% Georgia, 'MSung PRC Medium'",
      letterSpacing: '0px'
    },
    'paragraph-lg-styled': {
      font: "italic 400 18px/150% Georgia, 'MSung PRC Medium'",
      letterSpacing: '0px'
    },
    'paragraph-md': {
      font: "normal 400 16px/150% Georgia, 'MSung PRC Medium'",
      letterSpacing: '0px'
    },
    'paragraph-md-styled': {
      font: "italic 400 16px/150% Georgia, 'MSung PRC Medium'",
      letterSpacing: '0px'
    },
    'paragraph-sm': {
      font: "normal 400 14px/150% Georgia, 'MSung PRC Medium'",
      letterSpacing: '0px'
    },
    'paragraph-sm-styled': {
      font: "italic 400 14px/150% Georgia, 'MSung PRC Medium'",
      letterSpacing: '0px'
    },
    'label-lg': {
      font: "normal 400 16px/125% AkkuratPro, 'MSung PRC Medium'",
      letterSpacing: '0.16px'
    },
    'label-lg-bold': {
      font: "normal 700 16px/125% AkkuratPro, 'MSung PRC Medium'",
      letterSpacing: '0.16px'
    },
    'label-md': {
      font: "normal 400 14px/125% AkkuratPro, 'MSung PRC Medium'",
      letterSpacing: '0.14px'
    },
    'label-md-caps': {
      font: "normal 400 14px/125% AkkuratPro, 'MSung PRC Medium'",
      letterSpacing: '0.14px',
      textTransform: 'uppercase'
    },
    'label-md-wide-caps': {
      font: "normal 400 14px/125% AkkuratPro, 'MSung PRC Medium'",
      letterSpacing: '2.1px',
      textTransform: 'uppercase'
    },
    'label-md-strikethrough': {
      font: "normal 400 14px/125% AkkuratPro, 'MSung PRC Medium'",
      letterSpacing: '0.14px',
      textDecoration: 'line-through'
    },
    'label-md-bold': {
      font: "normal 700 14px/125% AkkuratPro, 'MSung PRC Medium'",
      letterSpacing: '0.14px'
    },
    'label-md-bold-caps': {
      font: "normal 700 14px/125% AkkuratPro, 'MSung PRC Medium'",
      letterSpacing: '0.14px',
      textTransform: 'uppercase'
    },
    'label-sm': {
      font: "normal 400 12px/125% AkkuratPro, 'MSung PRC Medium'",
      letterSpacing: '0.12px'
    },
    'label-sm-wide-caps': {
      font: "normal 400 12px/125% AkkuratPro, 'MSung PRC Medium'",
      letterSpacing: '1.8px',
      textTransform: 'uppercase'
    },
    'label-sm-bold': {
      font: "normal 700 12px/125% AkkuratPro, 'MSung PRC Medium'",
      letterSpacing: '0.12px'
    },
    'label-sm-bold-caps': {
      font: "normal 700 12px/125% AkkuratPro, 'MSung PRC Medium'",
      letterSpacing: '0.12px',
      textTransform: 'uppercase'
    },
    'badge-lg': {
      font: "normal 400 16px/150% AkkuratPro, 'MSung PRC Medium'",
      letterSpacing: '2.4px',
      textTransform: 'uppercase'
    },
    'badge-md': {
      font: "normal 400 14px/150% AkkuratPro, 'MSung PRC Medium'",
      letterSpacing: '2.1px',
      textTransform: 'uppercase'
    },
    'badge-sm': {
      font: "normal 400 12px/150% AkkuratPro, 'MSung PRC Medium'",
      letterSpacing: '1.8px',
      textTransform: 'uppercase'
    },
    quote: {
      font: "normal 400 32px/125% 'Chronicle Display', 'MSung PRC Medium'",
      letterSpacing: '0px',
      textDecoration: 'underline',
      '@media (min-width: 1024px)': {
        font: "normal 400 40px/125% 'Chronicle Display', 'MSung PRC Medium'"
      }
    },
    'quote-styled': {
      font: "italic 400 32px/125% 'Chronicle Display', 'MSung PRC Medium'",
      letterSpacing: '0px',
      textDecoration: 'underline',
      '@media (min-width: 1024px)': {
        font: "italic 400 40px/125% 'Chronicle Display', 'MSung PRC Medium'"
      }
    },
    caption: {
      font: "normal 400 12px/150% AkkuratPro, 'MSung PRC Medium'",
      letterSpacing: '0.6px'
    },
    emphasis: {
      font: "italic 400 24px/125% 'Chronicle Display', 'MSung PRC Medium'",
      letterSpacing: '0px',
      '@media (min-width: 1024px)': {
        font: "italic 400 32px/125% 'Chronicle Display', 'MSung PRC Medium'"
      }
    }
  },
  'nap-ar': {
    'header-2xl': {
      font: 'normal 700 66px/125% Amariya',
      letterSpacing: '0px',
      '@media (min-width: 1024px)': {
        font: 'normal 700 98px/125% Amariya'
      }
    },
    'header-2xl-styled': {
      font: 'normal 700 66px/125% Amariya',
      letterSpacing: '0px',
      '@media (min-width: 1024px)': {
        font: 'normal 700 98px/125% Amariya'
      }
    },
    'header-xl': {
      font: 'normal 700 50px/125% Amariya',
      letterSpacing: '0px',
      '@media (min-width: 1024px)': {
        font: 'normal 700 66px/125% Amariya'
      }
    },
    'header-xl-styled': {
      font: 'normal 700 50px/125% Amariya',
      letterSpacing: '0px',
      '@media (min-width: 1024px)': {
        font: 'normal 700 66px/125% Amariya'
      }
    },
    'header-lg': {
      font: 'normal 400 34px/125% Amariya',
      letterSpacing: '0px',
      '@media (min-width: 1024px)': {
        font: 'normal 400 50px/125% Amariya'
      }
    },
    'header-lg-styled': {
      font: 'normal 400 34px/125% Amariya',
      letterSpacing: '0px',
      '@media (min-width: 1024px)': {
        font: 'normal 400 50px/125% Amariya'
      }
    },
    'header-md': {
      font: 'normal 700 26px/125% Amariya',
      letterSpacing: '0px',
      '@media (min-width: 1024px)': {
        font: 'normal 700 34px/125% Amariya'
      }
    },
    'header-md-styled': {
      font: 'normal 700 26px/125% Amariya',
      letterSpacing: '0px',
      '@media (min-width: 1024px)': {
        font: 'normal 700 34px/125% Amariya'
      }
    },
    'header-sm': {
      font: 'normal 700 22px/125% Amariya',
      letterSpacing: '0px',
      '@media (min-width: 1024px)': {
        font: 'normal 700 26px/125% Amariya'
      }
    },
    'header-sm-styled': {
      font: 'normal 700 22px/125% Amariya',
      letterSpacing: '0px',
      '@media (min-width: 1024px)': {
        font: 'normal 700 26px/125% Amariya'
      }
    },
    'header-xs': {
      font: 'normal 700 22px/125% Amariya',
      letterSpacing: '0px'
    },
    'header-2xs': {
      font: 'normal 700 20px/125% Amariya',
      letterSpacing: '0px'
    },
    'header-3xs': {
      font: 'normal 700 18px/125% Amariya',
      letterSpacing: '0px'
    },
    'paragraph-lg-styled': {
      font: 'normal 400 18px/150% AkkuratProArabic',
      letterSpacing: '0px'
    },
    'paragraph-lg': {
      font: 'normal 400 18px/150% AkkuratProArabic',
      letterSpacing: '0px'
    },
    'paragraph-md-styled': {
      font: 'normal 400 16px/150% AkkuratProArabic',
      letterSpacing: '0px'
    },
    'paragraph-md': {
      font: 'normal 400 16px/150% AkkuratProArabic',
      letterSpacing: '0px'
    },
    'paragraph-sm': {
      font: 'normal 400 14px/150% AkkuratProArabic',
      letterSpacing: '0px'
    },
    'paragraph-sm-styled': {
      font: 'normal 400 16px/150% AkkuratProArabic',
      letterSpacing: '0px'
    },
    'label-lg': {
      font: 'normal 400 16px/125% AkkuratProArabic',
      letterSpacing: '0px'
    },
    'label-lg-bold': {
      font: 'normal 700 16px/125% AkkuratProArabic',
      letterSpacing: '0px'
    },
    'label-md-caps': {
      font: 'normal 400 14px/125% AkkuratProArabic',
      letterSpacing: '0px'
    },
    'label-md-wide-caps': {
      font: 'normal 400 14px/125% AkkuratProArabic',
      letterSpacing: '0px'
    },
    'label-md': {
      font: 'normal 400 14px/125% AkkuratProArabic',
      letterSpacing: '0px'
    },
    'label-md-strikethrough': {
      font: 'normal 400 14px/125% AkkuratProArabic',
      letterSpacing: '0px',
      textDecoration: 'line-through'
    },
    'label-md-bold-caps': {
      font: 'normal 700 14px/125% AkkuratProArabic',
      letterSpacing: '0px'
    },
    'label-md-bold': {
      font: 'normal 700 14px/125% AkkuratProArabic',
      letterSpacing: '0px'
    },
    'label-sm-wide-caps': {
      font: 'normal 400 12px/125% AkkuratProArabic',
      letterSpacing: '0px'
    },
    'label-sm': {
      font: 'normal 400 12px/125% AkkuratProArabic',
      letterSpacing: '0px'
    },
    'label-sm-bold': {
      font: 'normal 700 12px/125% AkkuratProArabic',
      letterSpacing: '0px'
    },
    'label-sm-bold-caps': {
      font: 'normal 700 12px/125% AkkuratProArabic',
      letterSpacing: '0px'
    },
    'badge-lg': {
      font: 'normal 400 16px/150% AkkuratProArabic',
      letterSpacing: '0px',
      textTransform: 'uppercase'
    },
    'badge-md': {
      font: 'normal 400 14px/150% AkkuratProArabic',
      letterSpacing: '0px',
      textTransform: 'uppercase'
    },
    'badge-sm': {
      font: 'normal 400 12px/150% AkkuratProArabic',
      letterSpacing: '0px'
    },
    'quote-styled': {
      font: 'normal 700 34px/125% Amariya',
      letterSpacing: '0px',
      '@media (min-width: 1024px)': {
        font: 'normal 700 42px/125% Amariya'
      }
    },
    quote: {
      font: 'normal 700 34px/125% Amariya',
      letterSpacing: '0px',
      '@media (min-width: 1024px)': {
        font: 'normal 700 42px/125% Amariya'
      }
    },
    caption: {
      font: 'normal 400 12px/150% AkkuratProArabic',
      letterSpacing: '0px'
    },
    emphasis: {
      font: 'normal 700 26px/125% Amariya',
      letterSpacing: '0px',
      '@media (min-width: 1024px)': {
        font: 'normal 700 34px/125% Amariya'
      }
    }
  },
  'nap-zh': {
    'header-2xl': {
      font: "normal 300 64px/125% 'Chronicle Display', 'MSung PRC Medium'",
      letterSpacing: '0px',
      '@media (min-width: 1024px)': {
        font: "normal 300 96px/125% 'Chronicle Display', 'MSung PRC Medium'"
      }
    },
    'header-2xl-styled': {
      font: "normal 300 64px/125% 'Chronicle Display', 'MSung PRC Medium'",
      letterSpacing: '0px',
      '@media (min-width: 1024px)': {
        font: "normal 300 96px/125% 'Chronicle Display', 'MSung PRC Medium'"
      }
    },
    'header-xl': {
      font: "normal 300 48px/125% 'Chronicle Display', 'MSung PRC Medium'",
      letterSpacing: '0px',
      '@media (min-width: 1024px)': {
        font: "normal 300 64px/125% 'Chronicle Display', 'MSung PRC Medium'"
      }
    },
    'header-xl-styled': {
      font: "normal 300 48px/125% 'Chronicle Display', 'MSung PRC Medium'",
      letterSpacing: '0px',
      '@media (min-width: 1024px)': {
        font: "normal 300 64px/125% 'Chronicle Display', 'MSung PRC Medium'"
      }
    },
    'header-lg': {
      font: "normal 300 32px/125% 'Chronicle Display', 'MSung PRC Medium'",
      letterSpacing: '0px',
      '@media (min-width: 1024px)': {
        font: "normal 300 48px/125% 'Chronicle Display', 'MSung PRC Medium'"
      }
    },
    'header-lg-styled': {
      font: "normal 300 32px/125% 'Chronicle Display', 'MSung PRC Medium'",
      letterSpacing: '0px',
      '@media (min-width: 1024px)': {
        font: "normal 300 48px/125% 'Chronicle Display', 'MSung PRC Medium'"
      }
    },
    'header-md': {
      font: "normal 400 24px/125% 'Chronicle Display', 'MSung PRC Medium'",
      letterSpacing: '0px',
      '@media (min-width: 1024px)': {
        font: "normal 400 32px/125% 'Chronicle Display', 'MSung PRC Medium'"
      }
    },
    'header-md-styled': {
      font: "italic 400 24px/125% 'Chronicle Display', 'MSung PRC Medium'",
      letterSpacing: '0px',
      '@media (min-width: 1024px)': {
        font: "italic 400 32px/125% 'Chronicle Display', 'MSung PRC Medium'"
      }
    },
    'header-sm': {
      font: "normal 400 20px/125% 'Chronicle Display', 'MSung PRC Medium'",
      letterSpacing: '0px',
      '@media (min-width: 1024px)': {
        font: "normal 400 24px/125% 'Chronicle Display', 'MSung PRC Medium'"
      }
    },
    'header-sm-styled': {
      font: "normal 400 20px/125% 'Chronicle Display', 'MSung PRC Medium'",
      letterSpacing: '0px',
      textTransform: 'uppercase',
      '@media (min-width: 1024px)': {
        font: "normal 400 24px/125% 'Chronicle Display', 'MSung PRC Medium'"
      }
    },
    'header-xs': {
      font: "normal 400 20px/125% 'Chronicle Display', 'MSung PRC Medium'",
      letterSpacing: '0px'
    },
    'header-2xs': {
      font: "normal 400 18px/125% 'Chronicle Display', 'MSung PRC Medium'",
      letterSpacing: '0px'
    },
    'header-3xs': {
      font: "normal 400 16px/125% 'Chronicle Display', 'MSung PRC Medium'",
      letterSpacing: '0px'
    },
    'paragraph-lg': {
      font: "normal 400 18px/150% 'Chronicle Display', 'MSung PRC Medium'",
      letterSpacing: '0px'
    },
    'paragraph-lg-styled': {
      font: "normal 400 18px/150% 'Chronicle Display', 'MSung PRC Medium'",
      letterSpacing: '0px'
    },
    'paragraph-md': {
      font: "normal 400 16px/150% Georgia, 'MSung PRC Medium'",
      letterSpacing: '0px'
    },
    'paragraph-md-styled': {
      font: "normal 400 16px/150% Georgia, 'MSung PRC Medium'",
      letterSpacing: '0px'
    },
    'paragraph-sm': {
      font: "normal 400 14px/150% 'Chronicle Display', 'MSung PRC Medium'",
      letterSpacing: '0px'
    },
    'paragraph-sm-styled': {
      font: "normal 400 14px/150% 'Chronicle Display', 'MSung PRC Medium'",
      letterSpacing: '0px'
    },
    'label-lg': {
      font: "normal 400 16px/125% AkkuratPro, 'MSung PRC Medium'",
      letterSpacing: '0.16px'
    },
    'label-lg-bold': {
      font: "normal 700 16px/125% AkkuratPro, 'MSung PRC Medium'",
      letterSpacing: '0.16px'
    },
    'label-md': {
      font: "normal 400 14px/125% AkkuratPro, 'MSung PRC Medium'",
      letterSpacing: '0.14px'
    },
    'label-md-caps': {
      font: "normal 400 14px/125% AkkuratPro, 'MSung PRC Medium'",
      letterSpacing: '0.14px'
    },
    'label-md-wide-caps': {
      font: "normal 400 14px/125% AkkuratPro, 'MSung PRC Medium'",
      letterSpacing: '2.1px',
      textTransform: 'uppercase'
    },
    'label-md-strikethrough': {
      font: "normal 400 14px/125% AkkuratPro, 'MSung PRC Medium'",
      letterSpacing: '0.14px',
      textDecoration: 'line-through'
    },
    'label-md-bold': {
      font: "normal 700 14px/125% AkkuratPro, 'MSung PRC Medium'",
      letterSpacing: '0.14px'
    },
    'label-md-bold-caps': {
      font: "normal 700 14px/125% AkkuratPro, 'MSung PRC Medium'",
      letterSpacing: '0.14px'
    },
    'label-sm': {
      font: "normal 400 12px/125% AkkuratPro, 'MSung PRC Medium'",
      letterSpacing: '0.12px'
    },
    'label-sm-wide-caps': {
      font: "normal 400 12px/125% AkkuratPro, 'MSung PRC Medium'",
      letterSpacing: '0.12px'
    },
    'label-sm-bold': {
      font: "normal 700 12px/125% AkkuratPro, 'MSung PRC Medium'",
      letterSpacing: '0.12px'
    },
    'label-sm-bold-caps': {
      font: "normal 700 12px/125% AkkuratPro, 'MSung PRC Medium'",
      letterSpacing: '0.12px'
    },
    'badge-lg': {
      font: "normal 400 16px/150% AkkuratPro, 'MSung PRC Medium'",
      letterSpacing: '2.4px',
      textTransform: 'uppercase'
    },
    'badge-md': {
      font: "normal 400 14px/150% AkkuratPro, 'MSung PRC Medium'",
      letterSpacing: '2.1px',
      textTransform: 'uppercase'
    },
    'badge-sm': {
      font: "normal 400 12px/150% AkkuratPro, 'MSung PRC Medium'",
      letterSpacing: '1.8px',
      textTransform: 'uppercase'
    },
    quote: {
      font: "normal 400 32px/125% 'Chronicle Display', 'MSung PRC Medium'",
      letterSpacing: '0px',
      textDecoration: 'underline',
      '@media (min-width: 1024px)': {
        font: "normal 400 40px/125% 'Chronicle Display', 'MSung PRC Medium'"
      }
    },
    'quote-styled': {
      font: "italic 400 32px/125% 'Chronicle Display', 'MSung PRC Medium'",
      letterSpacing: '0px',
      textDecoration: 'underline',
      '@media (min-width: 1024px)': {
        font: "italic 400 40px/125% 'Chronicle Display', 'MSung PRC Medium'"
      }
    },
    emphasis: {
      font: "normal 400 24px/125% 'Chronicle Display', 'MSung PRC Medium'",
      letterSpacing: '0px',
      '@media (min-width: 1024px)': {
        font: "normal 400 32px/125% 'Chronicle Display', 'MSung PRC Medium'"
      }
    },
    caption: {
      font: "normal 400 12px/150% AkkuratPro, 'MSung PRC Medium'",
      letterSpacing: '0.6px'
    }
  },
  'nap-jp': {
    'header-2xl': {
      font: 'normal 400 62px/140% NotoSansJP',
      letterSpacing: '0px',
      '@media (min-width: 1024px)': {
        font: 'normal 400 94px/140% NotoSansJP'
      }
    },
    'header-2xl-styled': {
      font: 'normal 400 62px/140% NotoSansJP',
      letterSpacing: '0px',
      '@media (min-width: 1024px)': {
        font: 'normal 400 94px/140% NotoSansJP'
      }
    },
    'header-xl': {
      font: 'normal 400 46px/140% NotoSansJP',
      letterSpacing: '0px',
      '@media (min-width: 1024px)': {
        font: 'normal 400 62px/140% NotoSansJP'
      }
    },
    'header-xl-styled': {
      font: 'normal 400 46px/140% NotoSansJP',
      letterSpacing: '0px',
      textTransform: 'uppercase',
      '@media (min-width: 1024px)': {
        font: 'normal 400 62px/140% NotoSansJP'
      }
    },
    'header-lg': {
      font: 'normal 400 30px/140% NotoSansJP',
      letterSpacing: '0px',
      '@media (min-width: 1024px)': {
        font: 'normal 400 46px/140% NotoSansJP'
      }
    },
    'header-lg-styled': {
      font: 'normal 400 30px/140% NotoSansJP',
      letterSpacing: '0px',
      '@media (min-width: 1024px)': {
        textTransform: 'uppercase',
        font: 'normal 400 46px/140% NotoSansJP'
      }
    },
    'header-md': {
      font: 'normal 400 22px/140% NotoSansJP',
      letterSpacing: '0px',
      '@media (min-width: 1024px)': {
        font: 'normal 400 30px/140% NotoSansJP'
      }
    },
    'header-md-styled': {
      font: 'normal 400 22px/140% NotoSansJP',
      letterSpacing: '0px',
      '@media (min-width: 1024px)': {
        font: 'normal 400 30px/140% NotoSansJP'
      }
    },
    'header-sm': {
      font: 'normal 400 18px/140% NotoSansJP',
      letterSpacing: '0px',
      '@media (min-width: 1024px)': {
        font: 'normal 400 22px/140% NotoSansJP'
      }
    },
    'header-sm-styled': {
      font: 'normal 400 18px/140% NotoSansJP',
      letterSpacing: '0px',
      '@media (min-width: 1024px)': {
        font: 'normal 400 22px/140% NotoSansJP'
      }
    },
    'header-xs': {
      font: 'normal 400 18px/140% NotoSansJP',
      letterSpacing: '0px'
    },
    'header-2xs': {
      font: 'normal 400 16px/140% NotoSansJP',
      letterSpacing: '0px'
    },
    'header-3xs': {
      font: 'normal 400 14px/140% NotoSansJP',
      letterSpacing: '0px'
    },
    'paragraph-lg': {
      font: 'normal 300 18px/180% NotoSansJP',
      letterSpacing: '0px'
    },
    'paragraph-lg-styled': {
      font: 'normal 300 18px/180% NotoSansJP',
      letterSpacing: '0px'
    },
    'paragraph-md': {
      font: 'normal 300 16px/180% NotoSansJP',
      letterSpacing: '0px'
    },
    'paragraph-md-styled': {
      font: 'normal 300 16px/180% NotoSansJP',
      letterSpacing: '0px'
    },
    'paragraph-sm': {
      font: 'normal 300 14px/180% NotoSansJP',
      letterSpacing: '0px'
    },
    'paragraph-sm-styled': {
      font: 'normal 300 14px/180% NotoSansJP',
      letterSpacing: '0px'
    },
    'label-lg': {
      font: 'normal 400 15px/140% NotoSansJP',
      letterSpacing: '0.15px'
    },
    'label-lg-bold': {
      font: 'normal 700 15px/140% NotoSansJP',
      letterSpacing: '0.15px'
    },
    'label-md': {
      font: 'normal 400 13px/140% NotoSansJP',
      letterSpacing: '0.13px'
    },
    'label-md-caps': {
      font: 'normal 400 13px/140% NotoSansJP',
      letterSpacing: '0.13px',
      textTransform: 'uppercase'
    },
    'label-md-wide-caps': {
      font: 'normal 400 13px/140% NotoSansJP',
      letterSpacing: '1.95px',
      textTransform: 'uppercase'
    },
    'label-md-strikethrough': {
      font: 'normal 400 13px/140% NotoSansJP',
      letterSpacing: '0.13px',
      textDecoration: 'line-through'
    },
    'label-md-bold': {
      font: 'normal 700 13px/140% NotoSansJP',
      letterSpacing: '0.13px'
    },
    'label-md-bold-caps': {
      font: 'normal 700 13px/140% NotoSansJP',
      letterSpacing: '0.13px',
      textTransform: 'uppercase'
    },
    'label-sm': {
      font: 'normal 400 11px/140% NotoSansJP',
      letterSpacing: '0.11px'
    },
    'label-sm-wide-caps': {
      font: 'normal 400 11px/140% NotoSansJP',
      letterSpacing: '1.65px',
      textTransform: 'uppercase'
    },
    'label-sm-bold': {
      font: 'normal 700 11px/140% NotoSansJP',
      letterSpacing: '0.11px'
    },
    'label-sm-bold-caps': {
      font: 'normal 700 11px/140% NotoSansJP',
      letterSpacing: '0.11px',
      textTransform: 'uppercase'
    },
    'badge-lg': {
      font: 'normal 400 15px/140% NotoSansJP',
      letterSpacing: '2.25px',
      textTransform: 'uppercase'
    },
    'badge-md': {
      font: 'normal 400 13px/140% NotoSansJP',
      letterSpacing: '1.95px',
      textTransform: 'uppercase'
    },
    'badge-sm': {
      font: 'normal 400 11px/140% NotoSansJP',
      letterSpacing: '1.65px',
      textTransform: 'uppercase'
    },
    quote: {
      font: 'normal 300 30px/140% NotoSansJP',
      letterSpacing: '0px',
      textDecoration: 'underline',
      '@media (min-width: 1024px)': {
        font: 'normal 300 38px/140% NotoSansJP'
      }
    },
    'quote-styled': {
      font: 'normal 300 30px/140% NotoSansJP',
      letterSpacing: '0px',
      textDecoration: 'underline',
      '@media (min-width: 1024px)': {
        font: 'normal 300 38px/140% NotoSansJP'
      }
    },
    caption: {
      font: 'normal 400 11px/180% NotoSansJP',
      letterSpacing: '0.55px'
    },
    emphasis: {
      font: 'normal 400 22px/140% NotoSansJP',
      letterSpacing: '0px',
      '@media (min-width: 1024px)': {
        font: 'normal 400 30px/140% NotoSansJP'
      }
    }
  },
  'nap-kr': {
    'header-2xl': {
      font: 'normal 300 64px/125% NotoSansKR',
      letterSpacing: '0px',
      '@media (min-width: 1024px)': {
        font: 'normal 300 96px/125% NotoSansKR'
      }
    },
    'header-2xl-styled': {
      font: 'normal 300 64px/125% NotoSansKR',
      letterSpacing: '0px',
      '@media (min-width: 1024px)': {
        font: 'normal 300 96px/125% NotoSansKR'
      }
    },
    'header-xl': {
      font: 'normal 300 48px/125% NotoSansKR',
      letterSpacing: '0px',
      '@media (min-width: 1024px)': {
        font: 'normal 300 64px/125% NotoSansKR'
      }
    },
    'header-xl-styled': {
      font: 'normal 300 48px/125% NotoSansKR',
      letterSpacing: '0px',
      '@media (min-width: 1024px)': {
        font: 'normal 300 64px/125% NotoSansKR'
      }
    },
    'header-lg': {
      font: 'normal 300 32px/125% NotoSansKR',
      letterSpacing: '0px',
      '@media (min-width: 1024px)': {
        font: 'normal 300 48px/125% NotoSansKR'
      }
    },
    'header-lg-styled': {
      font: 'normal 300 32px/125% NotoSansKR',
      letterSpacing: '0px',
      '@media (min-width: 1024px)': {
        font: 'normal 300 48px/125% NotoSansKR'
      }
    },
    'header-md': {
      font: 'normal 300 24px/125% NotoSansKR',
      letterSpacing: '0px',
      '@media (min-width: 1024px)': {
        font: 'normal 300 32px/125% NotoSansKR'
      }
    },
    'header-md-styled': {
      font: 'normal 300 24px/125% NotoSansKR',
      letterSpacing: '0px',
      '@media (min-width: 1024px)': {
        font: 'normal 300 32px/125% NotoSansKR'
      }
    },
    'header-sm': {
      font: 'normal 300 20px/125% NotoSansKR',
      letterSpacing: '0px',
      '@media (min-width: 1024px)': {
        font: 'normal 300 24px/125% NotoSansKR'
      }
    },
    'header-sm-styled': {
      font: 'normal 300 20px/125% NotoSansKR',
      letterSpacing: '0px',
      '@media (min-width: 1024px)': {
        font: 'normal 300 24px/125% NotoSansKR'
      }
    },
    'header-xs': {
      font: 'normal 300 20px/125% NotoSansKR',
      letterSpacing: '0px'
    },
    'header-2xs': {
      font: 'normal 300 18px/125% NotoSansKR',
      letterSpacing: '0px'
    },
    'header-3xs': {
      font: 'normal 300 16px/125% NotoSansKR',
      letterSpacing: '0px'
    },
    'paragraph-lg': {
      font: 'normal 300 18px/150% NotoSansKR',
      letterSpacing: '0px'
    },
    'paragraph-lg-styled': {
      font: 'normal 300 18px/150% NotoSansKR',
      letterSpacing: '0px'
    },
    'paragraph-md': {
      font: 'normal 300 16px/150% NotoSansKR',
      letterSpacing: '0px'
    },
    'paragraph-md-styled': {
      font: 'normal 300 16px/150% NotoSansKR',
      letterSpacing: '0px'
    },
    'paragraph-sm': {
      font: 'normal 300 14px/150% NotoSansKR',
      letterSpacing: '0px'
    },
    'paragraph-sm-styled': {
      font: 'normal 300 14px/150% NotoSansKR',
      letterSpacing: '0px'
    },
    'label-lg': {
      font: 'normal 400 16px/125% NotoSansKR',
      letterSpacing: '0.16px'
    },
    'label-lg-bold': {
      font: 'normal 700 16px/125% NotoSansKR',
      letterSpacing: '0.16px'
    },
    'label-md': {
      font: 'normal 400 14px/125% NotoSansKR',
      letterSpacing: '0.14px'
    },
    'label-md-caps': {
      font: 'normal 400 14px/125% NotoSansKR',
      letterSpacing: '0.14px',
      textTransform: 'uppercase'
    },
    'label-md-wide-caps': {
      font: 'normal 400 14px/125% NotoSansKR',
      letterSpacing: '2.1px',
      textTransform: 'uppercase'
    },
    'label-md-strikethrough': {
      font: 'normal 400 14px/125% NotoSansKR',
      letterSpacing: '0.14px',
      textDecoration: 'line-through'
    },
    'label-md-bold': {
      font: 'normal 700 14px/125% NotoSansKR',
      letterSpacing: '0.14px'
    },
    'label-md-bold-caps': {
      font: 'normal 700 14px/125% NotoSansKR',
      letterSpacing: '0.14px',
      textTransform: 'uppercase'
    },
    'label-sm': {
      font: 'normal 400 12px/125% NotoSansKR',
      letterSpacing: '0.12px'
    },
    'label-sm-wide-caps': {
      font: 'normal 400 12px/125% NotoSansKR',
      letterSpacing: '1.8px',
      textTransform: 'uppercase'
    },
    'label-sm-bold': {
      font: 'normal 700 12px/125% NotoSansKR',
      letterSpacing: '0.12px'
    },
    'label-sm-bold-caps': {
      font: 'normal 700 12px/125% NotoSansKR',
      letterSpacing: '0.12px',
      textTransform: 'uppercase'
    },
    'badge-lg': {
      font: 'normal 400 16px/150% NotoSansKR',
      letterSpacing: '2.4px',
      textTransform: 'uppercase'
    },
    'badge-md': {
      font: 'normal 400 14px/150% NotoSansKR',
      letterSpacing: '2.1px',
      textTransform: 'uppercase'
    },
    'badge-sm': {
      font: 'normal 400 12px/150% NotoSansKR',
      letterSpacing: '1.8px',
      textTransform: 'uppercase'
    },
    quote: {
      font: 'normal 300 32px/125% NotoSansKR',
      letterSpacing: '0px',
      textDecoration: 'underline',
      '@media (min-width: 1024px)': {
        font: 'normal 300 40px/125% NotoSansKR'
      }
    },
    'quote-styled': {
      font: 'normal 300 32px/125% NotoSansKR',
      letterSpacing: '0px',
      textDecoration: 'underline',
      '@media (min-width: 1024px)': {
        font: 'normal 300 40px/125% NotoSansKR'
      }
    },
    caption: {
      font: 'normal 400 12px/150% NotoSansKR',
      letterSpacing: '0.6px'
    },
    emphasis: {
      font: 'normal 300 24px/125% NotoSansKR',
      letterSpacing: '0px',
      '@media (min-width: 1024px)': {
        font: 'normal 300 32px/125% NotoSansKR'
      }
    }
  },
  'mrp-en': {
    'header-2xl': {
      font: 'normal 400 64px/125% Georgia',
      letterSpacing: '0px',
      '@media (min-width: 1024px)': {
        font: 'normal 400 72px/125% Georgia'
      }
    },
    'header-2xl-styled': {
      font: 'normal 900 48px/125% SackersGothicStd',
      letterSpacing: '0px',
      textTransform: 'uppercase',
      '@media (min-width: 1024px)': {
        font: 'normal 900 64px/125% SackersGothicStd'
      }
    },
    'header-xl': {
      font: 'normal 400 48px/125% Georgia',
      letterSpacing: '0px',
      '@media (min-width: 1024px)': {
        font: 'normal 400 64px/125% Georgia'
      }
    },
    'header-xl-styled': {
      font: 'normal 900 28px/125% SackersGothicStd',
      letterSpacing: '0px',
      textTransform: 'uppercase',
      '@media (min-width: 1024px)': {
        font: 'normal 900 40px/125% SackersGothicStd'
      }
    },
    'header-lg-styled': {
      font: 'normal 900 24px/125% SackersGothicStd',
      letterSpacing: '0px',
      textTransform: 'uppercase',
      '@media (min-width: 1024px)': {
        font: 'normal 900 32px/125% SackersGothicStd'
      }
    },
    'header-lg': {
      font: 'normal 400 32px/125% Georgia',
      letterSpacing: '0px',
      '@media (min-width: 1024px)': {
        font: 'normal 400 48px/125% Georgia'
      }
    },
    'header-md': {
      font: 'normal 400 24px/125% Georgia',
      letterSpacing: '0px',
      '@media (min-width: 1024px)': {
        font: 'normal 400 32px/125% Georgia'
      }
    },
    'header-md-styled': {
      font: 'normal 900 20px/125% SackersGothicStd',
      letterSpacing: '0px',
      textTransform: 'uppercase',
      '@media (min-width: 1024px)': {
        font: 'normal 900 24px/125% SackersGothicStd'
      }
    },
    'header-sm': {
      font: 'normal 400 20px/125% Georgia',
      letterSpacing: '0px',
      '@media (min-width: 1024px)': {
        font: 'normal 400 24px/125% Georgia'
      }
    },
    'header-sm-styled': {
      font: 'normal 900 14px/125% SackersGothicStd',
      letterSpacing: '0px',
      textTransform: 'uppercase',
      '@media (min-width: 1024px)': {
        font: 'normal 900 16px/125% SackersGothicStd'
      }
    },
    'header-xs': {
      font: 'normal 400 20px/125% Georgia',
      letterSpacing: '0px'
    },
    'header-2xs': {
      font: 'normal 400 18px/125% Georgia',
      letterSpacing: '0px'
    },
    'header-3xs': {
      font: 'normal 400 16px/125% Georgia',
      letterSpacing: '0px'
    },
    'paragraph-lg': {
      font: 'normal 400 18px/150% Georgia',
      letterSpacing: '0px'
    },
    'paragraph-lg-styled': {
      font: 'italic 400 18px/150% Georgia',
      letterSpacing: '0px'
    },
    'paragraph-md': {
      font: 'normal 400 16px/150% Georgia',
      letterSpacing: '0px'
    },
    'paragraph-md-styled': {
      font: 'italic 400 16px/150% Georgia',
      letterSpacing: '0px'
    },
    'paragraph-sm': {
      font: 'normal 400 14px/150% Georgia',
      letterSpacing: '0px'
    },
    'paragraph-sm-styled': {
      font: 'italic 400 14px/150% Georgia',
      letterSpacing: '0px'
    },
    'label-lg': {
      font: 'normal 400 16px/125% Georgia',
      letterSpacing: '0.16px'
    },
    'label-lg-bold': {
      font: 'normal 700 16px/125% Georgia',
      letterSpacing: '0.16px'
    },
    'label-md': {
      font: 'normal 400 14px/125% Georgia',
      letterSpacing: '0.14px'
    },
    'label-md-caps': {
      font: 'normal 400 14px/125% Georgia',
      letterSpacing: '0.14px',
      textTransform: 'uppercase'
    },
    'label-md-wide-caps': {
      font: 'normal 900 12px/125% SackersGothicStd',
      letterSpacing: '2.4px',
      textTransform: 'uppercase'
    },
    'label-md-strikethrough': {
      font: 'normal 400 14px/125% Georgia',
      letterSpacing: '0.14px',
      textDecoration: 'line-through'
    },
    'label-md-bold': {
      font: 'normal 700 14px/125% Georgia',
      letterSpacing: '0.14px'
    },
    'label-md-bold-caps': {
      font: 'normal 900 12px/125% SackersGothicStd',
      letterSpacing: '0.12px',
      textTransform: 'uppercase'
    },
    'label-sm': {
      font: 'normal 400 12px/125% Georgia',
      letterSpacing: '0.12px'
    },
    'label-sm-wide-caps': {
      font: 'normal 900 12px/125% SackersGothicStd',
      letterSpacing: '2.4px',
      textTransform: 'uppercase'
    },
    'label-sm-bold': {
      font: 'normal 700 12px/125% Georgia',
      letterSpacing: '0.12px'
    },
    'label-sm-bold-caps': {
      font: 'normal 900 10px/125% SackersGothicStd',
      letterSpacing: '0.1px',
      textTransform: 'uppercase'
    },
    'badge-lg': {
      font: 'normal 900 14px/150% SackersGothicStd',
      letterSpacing: '0px',
      textTransform: 'uppercase'
    },
    'badge-md': {
      font: 'normal 900 12px/150% SackersGothicStd',
      letterSpacing: '0px',
      textTransform: 'uppercase'
    },
    'badge-sm': {
      font: 'normal 900 10px/150% SackersGothicStd',
      letterSpacing: '0px',
      textTransform: 'uppercase'
    },
    quote: {
      font: 'normal 400 24px/125% Georgia',
      letterSpacing: '0px',
      '@media (min-width: 1024px)': {
        font: 'normal 400 32px/125% Georgia'
      }
    },
    'quote-styled': {
      font: 'italic 400 24px/125% Georgia',
      letterSpacing: '0px',
      '@media (min-width: 1024px)': {
        font: 'italic 400 32px/125% Georgia'
      }
    },
    caption: {
      font: 'normal 400 12px/150% Georgia',
      letterSpacing: '0px'
    },
    emphasis: {
      font: 'normal 400 32px/125% Mrporter',
      letterSpacing: '0px',
      '@media (min-width: 1024px)': {
        font: 'normal 400 48px/125% Mrporter'
      }
    }
  },
  'mrp-ar': {
    'header-2xl': {
      font: 'normal 700 70px/125% Amariya',
      letterSpacing: '0px',
      '@media (min-width: 1024px)': {
        font: 'normal 700 78px/125% Amariya'
      }
    },
    'header-2xl-styled': {
      font: 'normal 400 52px/125% NeueFrutigerRegular',
      letterSpacing: '0px',
      '@media (min-width: 1024px)': {
        font: 'normal 400 68px/125% NeueFrutigerRegular'
      }
    },
    'header-xl': {
      font: 'normal 700 54px/125% Amariya',
      letterSpacing: '0px',
      '@media (min-width: 1024px)': {
        font: 'normal 700 70px/125% Amariya'
      }
    },
    'header-xl-styled': {
      font: 'normal 400 32px/125% NeueFrutigerRegular',
      letterSpacing: '0px',
      '@media (min-width: 1024px)': {
        font: 'normal 400 44px/125% NeueFrutigerRegular'
      }
    },
    'header-lg': {
      font: 'normal 400 38px/125% Amariya',
      letterSpacing: '0px',
      '@media (min-width: 1024px)': {
        font: 'normal 400 54px/125% Amariya'
      }
    },
    'header-lg-styled': {
      font: 'normal 400 28px/125% NeueFrutigerRegular',
      letterSpacing: '0px',
      '@media (min-width: 1024px)': {
        font: 'normal 400 36px/125% NeueFrutigerRegular'
      }
    },
    'header-md': {
      font: 'normal 400 30px/125% Amariya',
      letterSpacing: '0px',
      '@media (min-width: 1024px)': {
        font: 'normal 400 38px/125% Amariya'
      }
    },
    'header-md-styled': {
      font: 'normal 400 24px/125% NeueFrutigerRegular',
      letterSpacing: '0px',
      '@media (min-width: 1024px)': {
        font: 'normal 400 28px/125% NeueFrutigerRegular'
      }
    },
    'header-sm': {
      font: 'normal 400 26px/125% Amariya',
      letterSpacing: '0px',
      '@media (min-width: 1024px)': {
        font: 'normal 400 30px/125% Amariya'
      }
    },
    'header-sm-styled': {
      font: 'normal 400 18px/125% NeueFrutigerRegular',
      letterSpacing: '0px',
      '@media (min-width: 1024px)': {
        font: 'normal 400 20px/125% NeueFrutigerRegular'
      }
    },
    'header-xs': {
      font: 'normal 400 26px/125% Amariya',
      letterSpacing: '0px'
    },
    'header-2xs': {
      font: 'normal 400 24px/125% Amariya',
      letterSpacing: '0px'
    },
    'header-3xs': {
      font: 'normal 400 22px/125% Amariya',
      letterSpacing: '0px'
    },
    'paragraph-lg': {
      font: 'normal 400 24px/150% Amariya',
      letterSpacing: '0px'
    },
    'paragraph-lg-styled': {
      font: 'normal 400 24px/150% Amariya',
      letterSpacing: '0px'
    },
    'paragraph-md': {
      font: 'normal 400 22px/150% Amariya',
      letterSpacing: '0px'
    },
    'paragraph-md-styled': {
      font: 'normal 400 18px/150% Amariya',
      letterSpacing: '0px'
    },
    'paragraph-sm': {
      font: 'normal 400 16px/150% Amariya',
      letterSpacing: '0px'
    },
    'paragraph-sm-styled': {
      font: 'normal 400 16px/150% Amariya',
      letterSpacing: '0px'
    },
    'label-lg': {
      font: 'normal 400 22px/125% Amariya',
      letterSpacing: '0px'
    },
    'label-lg-bold': {
      font: 'normal 700 22px/125% Amariya',
      letterSpacing: '0px'
    },
    'label-md': {
      font: 'normal 400 20px/125% Amariya',
      letterSpacing: '0px'
    },
    'label-md-caps': {
      font: 'normal 400 20px/125% Amariya',
      letterSpacing: '0px',
      textTransform: 'uppercase'
    },
    'label-md-wide-caps': {
      font: 'normal 400 16px/125% NeueFrutigerRegular',
      letterSpacing: '0px'
    },
    'label-md-strikethrough': {
      font: 'normal 400 20px/125% Amariya',
      letterSpacing: '0px',
      textDecoration: 'line-through'
    },
    'label-md-bold': {
      font: 'normal 700 20px/125% Amariya',
      letterSpacing: '0px'
    },
    'label-md-bold-caps': {
      font: 'normal 400 16px/125% NeueFrutigerRegular',
      letterSpacing: '0px'
    },
    'label-sm': {
      font: 'normal 400 18px/125% Amariya',
      letterSpacing: '0px'
    },
    'label-sm-wide-caps': {
      font: 'normal 400 14px/125% NeueFrutigerRegular',
      letterSpacing: '0px'
    },
    'label-sm bold': {
      font: 'normal 700 18px/125% Amariya',
      letterSpacing: '0px'
    },
    'label-sm-bold-caps': {
      font: 'normal 400 14px/125% NeueFrutigerRegular',
      letterSpacing: '0px'
    },
    'badge-lg': {
      font: 'normal 400 18px/150% NeueFrutigerRegular',
      letterSpacing: '0px'
    },
    'badge-md': {
      font: 'normal 400 16px/150% NeueFrutigerRegular',
      letterSpacing: '0px'
    },
    'badge-sm': {
      font: 'normal 400 14px/150% NeueFrutigerRegular',
      letterSpacing: '0px'
    },
    qoute: {
      font: 'normal 400 30px/125% Amariya',
      letterSpacing: '0px',
      '@media (min-width: 1024px)': {
        font: 'normal 400 38px/125% Amariya'
      }
    },
    'qoute-styled': {
      font: 'normal 400 30px/125% Amariya',
      letterSpacing: '0px',
      '@media (min-width: 1024px)': {
        font: 'normal 400 38px/125% Amariya'
      }
    },
    caption: {
      font: 'normal 400 18px/150% Amariya',
      letterSpacing: '0px'
    },
    emphasis: {
      font: 'normal 400 34px/125% Amariya',
      letterSpacing: '0px',
      '@media (min-width: 1024px)': {
        font: 'normal 400 50px/125% Amariya'
      }
    }
  },
  'mrp-jp': {
    'header-2xl': {
      font: 'normal 500 64px/140% NotoSansJP',
      letterSpacing: '0px',
      '@media (min-width: 1024px)': {
        font: 'normal 500 72px/140% NotoSansJP'
      }
    },
    'header-2xl-styled': {
      font: 'normal 700 48px/140% NotoSansJP',
      letterSpacing: '0px',
      textTransform: 'uppercase',
      '@media (min-width: 1024px)': {
        font: 'normal 700 64px/140% NotoSansJP'
      }
    },
    'header-xl': {
      font: 'normal 500 48px/140% NotoSansJP',
      letterSpacing: '0px',
      '@media (min-width: 1024px)': {
        font: 'normal 500 64px/140% NotoSansJP'
      }
    },
    'header-xl-styled': {
      font: 'normal 700 28px/140% NotoSansJP',
      letterSpacing: '0px',
      textTransform: 'uppercase',
      '@media (min-width: 1024px)': {
        font: 'normal 700 40px/140% NotoSansJP'
      }
    },
    'header-lg': {
      font: 'normal 500 32px/140% NotoSansJP',
      letterSpacing: '0px',
      '@media (min-width: 1024px)': {
        font: 'normal 500 48px/140% NotoSansJP'
      }
    },
    'header-lg-styled': {
      font: 'normal 700 24px/140% NotoSansJP',
      letterSpacing: '0px',
      textTransform: 'uppercase',
      '@media (min-width: 1024px)': {
        font: 'normal 700 32px/140% NotoSansJP'
      }
    },
    'header-md': {
      font: 'normal 500 24px/140% NotoSansJP',
      letterSpacing: '0px',
      textTransform: 'uppercase',
      '@media (min-width: 1024px)': {
        font: 'normal 500 32px/140% NotoSansJP'
      }
    },
    'header-md-styled': {
      font: 'normal 700 20px/140% NotoSansJP',
      letterSpacing: '0px',
      textTransform: 'uppercase',
      '@media (min-width: 1024px)': {
        font: 'normal 700 24px/140% NotoSansJP'
      }
    },
    'header-sm': {
      font: 'normal 500 20px/140% NotoSansJP',
      letterSpacing: '0px',
      textTransform: 'uppercase',
      '@media (min-width: 1024px)': {
        font: 'normal 500 24px/140% NotoSansJP'
      }
    },
    'header-sm-styled': {
      font: 'normal 700 14px/140% NotoSansJP',
      letterSpacing: '0px',
      textTransform: 'uppercase',
      '@media (min-width: 1024px)': {
        font: 'normal 700 16px/140% NotoSansJP'
      }
    },
    'header-xs': {
      font: 'normal 500 20px/140% NotoSansJP',
      letterSpacing: '0px',
      textTransform: 'uppercase'
    },
    'header-2xs': {
      font: 'normal 500 18px/140% NotoSansJP',
      letterSpacing: '0px',
      textTransform: 'uppercase'
    },
    'header-3xs': {
      font: 'normal 500 16px/140% NotoSansJP',
      letterSpacing: '0px',
      textTransform: 'uppercase'
    },
    'paragraph-lg': {
      font: 'normal 500 18px/180% NotoSansJP',
      letterSpacing: '0px'
    },
    'paragraph-lg-styled': {
      font: 'normal 500 18px/180% NotoSansJP',
      letterSpacing: '0px'
    },
    'paragraph-md': {
      font: 'normal 500 16px/180% NotoSansJP',
      letterSpacing: '0px'
    },
    'paragraph-md-styled': {
      font: 'normal 500 16px/180% NotoSansJP',
      letterSpacing: '0px'
    },
    'paragraph-sm': {
      font: 'normal 400 14px/180% NotoSansJP',
      letterSpacing: '0px'
    },
    'paragraph-sm-styled': {
      font: 'normal 500 14px/180% NotoSansJP',
      letterSpacing: '0px'
    },
    'label-sm': {
      font: 'normal 400 12px/140% NotoSansJP',
      letterSpacing: '0.12px',
      textTransform: 'uppercase'
    },
    'label-md-bold-caps': {
      font: 'normal 700 12px/140% NotoSansJP',
      letterSpacing: '0.12px'
    },
    'label-md-bold': {
      font: 'normal 700 16px/140% NotoSansJP',
      letterSpacing: '0.16px',
      textTransform: 'uppercase'
    },
    'label-lg': {
      font: 'normal 400 16px/140% NotoSansJP',
      letterSpacing: '0.16px',
      textTransform: 'uppercase'
    },
    'label-lg-bold': {
      font: 'normal 700 16px/140% NotoSansJP',
      letterSpacing: '0.16px',
      textTransform: 'uppercase'
    },
    'label-md': {
      font: 'normal 400 14px/140% NotoSansJP',
      letterSpacing: '0.14px',
      textTransform: 'uppercase'
    },
    'label-md-wide-caps': {
      font: 'normal 700 12px/140% NotoSansJP',
      letterSpacing: '2.4px'
    },
    'label-sm-wide-caps': {
      font: 'normal 700 12px/140% NotoSansJP',
      letterSpacing: '2.4px'
    },
    'label-sm-bold': {
      font: 'normal 700 12px/140% NotoSansJP',
      letterSpacing: '0.12px',
      textTransform: 'uppercase'
    },
    'label-sm-bold-caps': {
      font: 'normal 700 10px/140% NotoSansJP',
      letterSpacing: '0px'
    },
    'label-md-caps': {
      font: 'normal 400 14px/125% NotoSansJP',
      letterSpacing: '0px'
    },
    'badge-lg': {
      font: 'normal 900 14px/140% NotoSansJP',
      letterSpacing: '0px',
      textTransform: 'uppercase'
    },
    'badge-md': {
      font: 'normal 900 12px/140% NotoSansJP',
      letterSpacing: '0px',
      textTransform: 'uppercase'
    },
    'badge-sm': {
      font: 'normal 900 10px/140% NotoSansJP',
      letterSpacing: '0px',
      textTransform: 'uppercase'
    },
    caption: {
      font: 'normal 400 12px/140% NotoSansJP',
      letterSpacing: '0.12px',
      textTransform: 'uppercase'
    },
    emphasis: {
      font: 'normal 500 32px/140% NotoSansJP',
      letterSpacing: '0px',
      '@media (min-width: 1024px)': {
        font: 'normal 500 48px/140% NotoSansJP'
      }
    }
  },
  'mrp-kr': {
    'header-2xl': {
      font: 'normal 400 64px/125% NotoSansKR',
      letterSpacing: '0px',
      '@media (min-width: 1024px)': {
        font: 'normal 400 72px/125% NotoSansKR'
      }
    },
    'header-2xl-styled': {
      font: 'normal 900 48px/125% NotoSansKR',
      letterSpacing: '0px',
      '@media (min-width: 1024px)': {
        font: 'normal 900 64px/125% NotoSansKR'
      }
    },
    'header-xl': {
      font: 'normal 400 48px/125% NotoSansKR',
      letterSpacing: '0px',
      '@media (min-width: 1024px)': {
        font: 'normal 400 64px/125% NotoSansKR'
      }
    },
    'header-xl-styled': {
      font: 'normal 900 28px/125% NotoSansKR',
      letterSpacing: '0px',
      '@media (min-width: 1024px)': {
        font: 'normal 900 40px/125% NotoSansKR'
      }
    },
    'header-lg': {
      font: 'normal 400 32px/125% NotoSansKR',
      letterSpacing: '0px',
      '@media (min-width: 1024px)': {
        font: 'normal 400 48px/125% NotoSansKR'
      }
    },
    'header-lg-styled': {
      font: 'normal 900 24px/125% NotoSansKR',
      letterSpacing: '0px',
      '@media (min-width: 1024px)': {
        font: 'normal 900 32px/125% NotoSansKR'
      }
    },
    'header-md': {
      font: 'normal 400 24px/125% NotoSansKR',
      letterSpacing: '0px',
      '@media (min-width: 1024px)': {
        font: 'normal 400 32px/125% NotoSansKR'
      }
    },
    'header-md-styled': {
      font: 'normal 900 20px/125% NotoSansKR',
      letterSpacing: '0px',
      textTransform: 'uppercase',
      '@media (min-width: 1024px)': {
        font: 'normal 900 24px/125% NotoSansKR'
      }
    },
    'header-sm': {
      font: 'normal 400 20px/125% NotoSansKR',
      letterSpacing: '0px',
      '@media (min-width: 1024px)': {
        font: 'normal 400 24px/125% NotoSansKR'
      }
    },
    'header-sm-styled': {
      font: 'normal 900 14px/125% NotoSansKR',
      letterSpacing: '0px',
      textTransform: 'uppercase',
      '@media (min-width: 1024px)': {
        font: 'normal 900 16px/125% NotoSansKR'
      }
    },
    'header-xs': {
      font: 'normal 400 20px/125% NotoSansKR',
      letterSpacing: '0px'
    },
    'header-2xs': {
      font: 'normal 400 18px/125% NotoSansKR',
      letterSpacing: '0px'
    },
    'header-3xs': {
      font: 'normal 400 16px/125% NotoSansKR',
      letterSpacing: '0px'
    },
    'paragraph-lg': {
      font: 'normal 400 18px/150% NotoSansKR',
      letterSpacing: '0px'
    },
    'paragraph-lg-styled': {
      font: 'normal 400 18px/150% NotoSansKR',
      letterSpacing: '0px'
    },
    'paragraph-md': {
      font: 'normal 400 16px/150% NotoSansKR',
      letterSpacing: '0px'
    },
    'paragraph-md-styled': {
      font: 'normal 400 16px/150% NotoSansKR',
      letterSpacing: '0px'
    },
    'paragraph-sm': {
      font: 'normal 400 14px/150% NotoSansKR',
      letterSpacing: '0px'
    },
    'paragraph-sm-styled': {
      font: 'normal 400 14px/150% NotoSansKR',
      letterSpacing: '0px'
    },
    'label-lg': {
      font: 'normal 400 16px/125% NotoSansKR',
      letterSpacing: '0.16px'
    },
    'label-lg-bold': {
      font: 'normal 700 16px/125% NotoSansKR',
      letterSpacing: '0.16px'
    },
    'label-md': {
      font: 'normal 400 14px/125% NotoSansKR',
      letterSpacing: '0.14px'
    },
    'label-md-caps': {
      font: 'normal 400 14px/125% NotoSansKR',
      letterSpacing: '0.14px'
    },
    'label-md-wide-caps': {
      font: 'normal 900 12px/125% NotoSansKR',
      letterSpacing: '2.4px'
    },
    'label-md-strikethrough': {
      font: 'normal 400 14px/125% NotoSansKR',
      letterSpacing: '0.14px',
      textDecoration: 'line-through'
    },
    'label-md-bold': {
      font: 'normal 700 14px/125% NotoSansKR',
      letterSpacing: '0.14px'
    },
    'label-md-bold-caps': {
      font: 'normal 900 12px/125% NotoSansKR',
      letterSpacing: '0.12px'
    },
    'label-sm': {
      font: 'normal 400 12px/125% NotoSansKR',
      letterSpacing: '0.12px'
    },
    'label-sm-wide-caps': {
      font: 'normal 900 12px/125% NotoSansKR',
      letterSpacing: '2.4px'
    },
    'label-sm-bold': {
      font: 'normal 700 12px/125% NotoSansKR',
      letterSpacing: '0.12px'
    },
    'label-sm-bold-caps': {
      font: 'normal 900 10px/125% NotoSansKR',
      letterSpacing: '0.1px'
    },
    'badge-lg': {
      font: 'normal 900 14px/150% NotoSansKR',
      letterSpacing: '0px'
    },
    'badge-md': {
      font: 'normal 900 12px/150% NotoSansKR',
      letterSpacing: '0px'
    },
    'badge-sm': {
      font: 'normal 900 10px/150% NotoSansKR',
      letterSpacing: '0px'
    },
    quote: {
      font: 'normal 400 24px/125% NotoSansKR',
      letterSpacing: '0px',
      '@media (min-width: 1024px)': {
        font: 'normal 400 32px/125% NotoSansKR'
      }
    },
    'quote-styled': {
      font: 'normal 400 24px/125% NotoSansKR',
      letterSpacing: '0px',
      '@media (min-width: 1024px)': {
        font: 'normal 400 32px/125% NotoSansKR'
      }
    },
    caption: {
      font: 'normal 400 12px/150% NotoSansKR',
      letterSpacing: '0px'
    },
    emphasis: {
      font: 'normal 400 32px/125% NotoSansKR',
      letterSpacing: '0px',
      '@media (min-width: 1024px)': {
        font: 'normal 400 48px/125% NotoSansKR'
      }
    }
  }
}
